import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, IconButton, PopoverPaper, Tooltip } from "@mui/material";
import {
  CloseRounded,
  DescriptionRounded,
  MoreVertRounded,
  PlayArrowRounded,
} from "@mui/icons-material";
import { COLORS } from "../../context/initialValues";
const ExamCard = (props) => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  useEffect(() => {
    async function disabledButton() {
      setDisabled(!props.exam.total_questions);
    }
    disabledButton();
  }, [props.exam, props.token]);

  async function copyUrl(e, examName, examId) {
    e.stopPropagation();
    e.preventDefault();
    if (disabled) return;

    const encodedExamName = encodeURIComponent(examName);
    const examUrl = `https://assessive.net/${encodedExamName}/${examId}`;

    if (navigator.share) {
      await navigator.share({
        title: "Assessive",
        text: `Take this exam: ${examName}`,
        url: examUrl,
      });
    } else {
      await navigator.clipboard.writeText(examUrl);
    }
  }

  function handleClose(e) {
    e.preventDefault();
    setShowMenu(false);
  }

  function startExam(e) {
    e.preventDefault();
    const encodedName = encodeURIComponent(props.exam.name);
    navigate(`/${encodedName}/`, {
      state: { examId: props.exam.id },
    });
  }
  return (
    <div
      className="exam-flex-box"
      style={{ borderLeft: `4px solid ${COLORS[props.index % 4].border}` }}
    >
      <div className="top-text">
        <h2>{props.exam.name}</h2>

        <p>{props.exam.description}</p>
      </div>
      <div className="bottom-row">
        <p className="mb-0">
          <DescriptionRounded fontSize="small" /> {props.exam.total_questions}{" "}
          questions
        </p>

        <Button
          variant="contained"
          color={`${COLORS[props.index % 4].button}`}
          disableElevation
          size="small"
          className="py-1 px-4 desktop-button"
          disabled={disabled}
          onClick={startExam}
        >
          <Tooltip
            title={disabled ? "Please add questions to this exam." : ""}
            placement="bottom"
            arrow
          >
            {Object.keys(props.exam.progress_data).length !== 0
              ? "Resume"
              : "Start Exam"}
          </Tooltip>
        </Button>
        <Button
          color={`${COLORS[props.index % 4].button}`}
          disableElevation
          variant="contained"
          size="small"
          className="mobile-button p-1"
          sx={{
            minWidth: "fit-content",
          }}
          disabled={disabled}
          onClick={startExam}
        >
          <Tooltip
            title={disabled ? "Please add questions to this exam." : ""}
            placement="bottom"
            arrow
          >
            <PlayArrowRounded sx={{ color: "inherit" }} />
          </Tooltip>
        </Button>
      </div>

      <IconButton
        sx={{ position: "absolute", top: 0, right: 0 }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setShowMenu(!showMenu);
        }}
      >
        {showMenu ? <CloseRounded /> : <MoreVertRounded />}
      </IconButton>
      <PopoverPaper
        square={false}
        sx={{
          position: "absolute",
          right: 10,
          top: 40,
          boxShadow: "var(--box-shadow)",
          zIndex: 100001,
        }}
        className="popover-menu"
        hidden={!showMenu}
        open={showMenu}
        onClose={(e) => handleClose(e)}
        onMouseLeave={(e) => setTimeout(() => handleClose(e), 500)}
      >
        <ul className="menu">
          <li>
            <div
              className="menu-link"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                navigate(`/exams/${props.exam.id}`);
              }}
            >
              Edit
            </div>
          </li>
          <li className="no-border">
            <div
              className="menu-link"
              onClick={(e) => copyUrl(e, props.exam.name)}
            >
              Share
            </div>
          </li>
        </ul>
      </PopoverPaper>
    </div>
  );
};

export default ExamCard;
